import { render, staticRenderFns } from "./ClosedNotifications.vue?vue&type=template&id=052ac382&scoped=true"
import script from "./ClosedNotifications.vue?vue&type=script&lang=ts"
export * from "./ClosedNotifications.vue?vue&type=script&lang=ts"
function injectStyles (context) {
  
  var style0 = require("./ClosedNotifications.vue?vue&type=style&index=0&id=052ac382&prod&lang=scss&scoped=true")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "052ac382",
  null
  ,true
)

export default component.exports